import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import PageTracker from '../../../../common/PageTrackerHelper'

export default {
  name: 'LostShipments',
  components: {
    VueElementLoading,
    Paginate,
  },
  mixins:[PageTracker],
  data: function() {
    return {
      hubzoneid: '',
      hubname: '',
      awbnumbers: '',
      amountcomparator:'',
      netpaymnet:'',
      debittype:'',
      substatus: '',
      fromDate:'',
      toDate:'',
      pendingdays:'',
      hubZoneList:[],
      hubServiceCenterList:[],
      listLostShipmentsData:[],
      listLostShipmentsDataCSV:[],
      pageno: 1,
      pagecount: 0,
      perpage:10,
      isLoading: false,
      localhubdetails:'',
      localuserid:'',
      localhubdetails:'',
      resultCount:0,
      getAttachmentListData: [],
      getAttachmentFlag: false,
      attachmentLoader: false,
      totalRecord:0,
      userDataKey : '',
    }
  },
  created: function() {
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];

    this.getHubZoneData();
    this.getHubServiceCenterData();
    this.getLostShipmentsData();

    //console.log('Mixin is working for :',result);
  },
  methods: {

    //to get Hub Zone list
    getHubZoneData() {
      axios.get(apiUrl.api_url + 'external/gethubzonelist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubZoneList=response.data.data;
            }
            else {
                this.hubZoneList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.success("Hub Zone data not found");
              console.error('exception is:::::::::', httpException)
        })
    },
    //to get Zone wise Hub Service Center list
    getZoneHubServiceCenterData() {
      if(this.hubzoneid==0){
        return false;
      }
      axios.get(apiUrl.api_url + 'external/getzonewisehublist?zoneid='+this.hubzoneid, {})
        .then((response) => {
            if(response.data.code===200){
                this.hubname='';
                this.hubServiceCenterList=response.data.data;
                this.hubServiceCenterList.sort(function(a, b){
                 var nameA=a.HubName.toLowerCase(), nameB=b.HubName.toLowerCase()
                 if (nameA < nameB) //sort string ascending
                  return -1
                 if (nameA > nameB)
                  return 1
                 return 0 //default return value (no sorting)
                });
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.success("Hub Service Center data not found");
              console.error('exception is:::::::::', httpException)
        })
    },

    //to get Hub Service Center list
    getHubServiceCenterData() {
      axios.get(apiUrl.api_url + 'external/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList=response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.success("Hub Service Center data not found");
              console.error('exception is:::::::::', httpException)
        })

    },

    getShipmentAttachmentPopup(shippingID){
      this.attachmentLoader = true
      this.getAttachmentFlag= true
      let data={
        ShippingID: shippingID
      }
      axios.post(apiUrl.api_url + 'Lost/ShippindID/AttachmentDownload',data)
        .then((response) => {
            if(response.data.code == 200){
               this.getAttachmentListData = response.data.data;
            } else {
              this.getAttachmentListData = [];
            }
            this.attachmentLoader = false;
          })
        .catch((httpException) => {
             this.attachmentLoader = false;
            console.error('exception is:::::::::',httpException)
        });
    },
    closeAttachmentPopup(){
     this.getAttachmentFlag = false
    },

    //to get pagination
    getPaginationData(pageNum) {
        this.pageno = pageNum;
        this.getLostShipmentsData();
    },

    //search Raise Debit data
    searchLostShipmentsData(){
      this.pageno = 1;
      this.searchflag = true;
      this.$refs.paginate.selected= 0;
      this.getLostShipmentsData();
    },
    changeDateFormat(inputString){
      let current_datetime = new Date(inputString)
      let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear();
      return formatted_date;
    },
    //to get Raise Debit Data
    getLostShipmentsData() {
        let payload = {};
        if(this.awbnumbers!="") {
          payload.ShippingID = this.awbnumbers.split(",");
        }
        if(this.hubzoneid!="") payload.HubZoneID = this.hubzoneid;
        if(this.hubname!="") payload.HubID = this.hubname;
        if(this.amountcomparator!="") payload.OctroiMRP = this.amountcomparator;

        if(this.amountcomparator!=""){
          payload.OctroiMRP = this.amountcomparator+'/'+this.netpaymnet;
        }else if (this.netpaymnet!="") {
          payload.OctroiMRP = '=/'+this.netpaymnet;
        }

        if(this.debittype!="") payload.DebitFromType = this.debittype;
        if(this.substatus!="") payload.SubStatus = this.substatus;
        if(this.fromDate!="") payload.FromDate = this.fromDate;
        if(this.toDate!="") payload.ToDate = this.toDate;
        if(this.pendingdays!="") payload.PendingDays = this.pendingdays;
        payload.pageNo = this.pageno;
        payload.pageSize = this.perpage;

        this.isLoading = true;
        axios({
                method: 'POST',
                'url': apiUrl.api_url + 'lostShipmentDetail/search',
                'data': payload
            })
            .then(result => {
                let debitData = result.data.data;
                let temparr = [];
                let temparrCSV = [];
                if(debitData!=null){
                  debitData.forEach((debit)=>{
                    var newcreateddate = this.changeDateFormat(debit.CreatedDate);
                    temparr.push({"ShippingID":debit.ShippingID,
                                 "PendingDays":debit.PendingDays,
                                 "PrevBucket":debit.PrevBucket,
                                 "CreatedDate":newcreateddate,
                                 "Comments":debit.Comments,
                                 "OctroiMRP":debit.OctroiMRP,
                                 "DebitAmount":debit.DebitAmount,
                                 "HubZoneName":debit.HubZoneName,
                                 "HubName":debit.HubName
                               });
                       temparrCSV.push({"ShippingID":debit.ShippingID,
                                    "PendingDays":debit.PendingDays,
                                    "PrevBucket":debit.PrevBucket,
                                    "CreatedDate":newcreateddate,
                                    "Comments":debit.Comments,
                                    "OctroiMRP":debit.OctroiMRP,
                                    "DebitAmount":debit.DebitAmount,
                                    "HubZoneName":debit.HubZoneName,
                                    "HubName":debit.HubName
                                  });
                  });
                }
                this.listLostShipmentsData = temparr;
                this.listLostShipmentsDataCSV = temparrCSV;
                this.isLoading = false;
                let totalRows = 0;
                if(result.data.totalCount!=undefined){
                  totalRows = result.data.totalCount;
                }
                this.resultCount = totalRows;
                this.totalRecord = totalRows
                if (totalRows < this.perpage) {
                    this.pagecount = 1
                } else {
                    this.pagecount = Math.ceil(totalRows / this.perpage)
                }
            }, error => {
                console.error(error)
            })
    },

    //to get Shipment Log
    getShipmentLogData(ShippingID) {

      this.$validator.reset();
      this.errors.clear();

      axios.get(apiUrl.api_url + `external/getshipmentlog?ShippingID=${ShippingID}`)
        .then((response) => {
            this.shipmentlogmodal = true;
            if(response.data.code===200){
                this.shipmentLogList = response.data.data;
            }
            else {
                this.shipmentLogList = [];
            }
        })
        .catch((httpException) => {
              this.$alertify.success("Shpment Log data not found");
              console.error('exception is:::::::::', httpException)
        })

    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.searchLostShipmentsData(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    exportForm(){
      let payload = {};
      if(this.awbnumbers!="") {
        payload.ShippingID = this.awbnumbers.split(",");
      }
      if(this.hubzoneid!="") payload.HubZoneID = this.hubzoneid;
      if(this.hubname!="") payload.HubID = this.hubname;
      if(this.amountcomparator!="") payload.OctroiMRP = this.amountcomparator;

      if(this.amountcomparator!=""){
        payload.OctroiMRP = this.amountcomparator+'/'+this.netpaymnet;
      }else if (this.netpaymnet!="") {
        payload.OctroiMRP = '=/'+this.netpaymnet;
      }

      if(this.debittype!="") payload.DebitFromType = this.debittype;
      if(this.substatus!="") payload.SubStatus = this.substatus;
      if(this.fromDate!="") payload.FromDate = this.fromDate;
      if(this.toDate!="") payload.ToDate = this.toDate;
      if(this.pendingdays!="") payload.PendingDays = this.pendingdays;
      payload.pageNo = this.pageno;
      payload.pageSize = this.perpage;
      payload.exportFlag = '1'
      axios({
              method: 'POST',
              'url': apiUrl.api_url + 'lostShipmentDetail/search',
              'data': payload
          })
          .then(result => {
              let debitData = result.data.data;
              let temparr = [];
              let temparrCSV = [];
              if(debitData!=null){
                debitData.forEach((debit)=>{
                  var newcreateddate = this.changeDateFormat(debit.CreatedDate);
                     temparrCSV.push({"ShippingID":debit.ShippingID,
                                  "PendingDays":debit.PendingDays,
                                  "PrevBucket":debit.PrevBucket,
                                  "CreatedDate":newcreateddate,
                                  "Comments":debit.Comments,
                                  "OctroiMRP":debit.OctroiMRP,
                                  "DebitAmount":debit.DebitAmount,
                                  "HubZoneName":debit.HubZoneName,
                                  "HubName":debit.HubName
                                });
                });
              }

              this.listLostShipmentsDataCSV = temparrCSV;
              if(this.listLostShipmentsDataCSV==undefined || this.listLostShipmentsDataCSV.length==0){
                this.$alertify.alert("No data","No data available for download.");
              }
              this.getDownloadCsvObject(this.listLostShipmentsDataCSV);

          }, error => {
              console.error(error)
          })
    },
    getDownloadCsvObject(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "LostShipmentDetails_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
   },
    resetForm() {
        this.$validator.reset();
        this.errors.clear();
        this.hubzoneid = '';
        this.hubname = '';
        this.awbnumbers = '';
        this.amountcomparator = '';
        this.netpaymnet = '';
        this.debittype = '';
        this.substatus = '';
        this.fromDate = '';
        this.toDate = '';
        this.pendingdays = '';
        this.pageno = 1;
        this.$refs.paginate.selected= 0;
        this.getHubServiceCenterData();
        this.getLostShipmentsData();
    },
    onlyNumber : function($event){
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
       if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 8 && keyCode !== 44 && keyCode !== 190) {
          $event.preventDefault();
       }
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/LostShipmentDetails/LostShipmentDetails.component.js